import { Link, useLocation } from "react-router-dom";

/**
 * Sticky comparison bar — swaps the user between the two brand variants
 * of the landing page. Intentionally neutral-coloured so it
 * sits above both palettes without borrowing from either.
 *
 * This is the ONLY element that exists outside both brand scopes.
 */
export function CompareBar() {
  const location = useLocation();
  const isA = location.pathname.includes("brand-a");

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        background: "#0F2A2A",
        color: "#F4EFE4",
        fontFamily: "'Geist Mono', ui-monospace, monospace",
        fontSize: 12,
        padding: "10px 20px",
        display: "flex",
        alignItems: "center",
        gap: 14,
        letterSpacing: 0.4,
        borderBottom: "1px solid rgba(244,239,228,0.1)",
      }}
    >
      <span style={{ textTransform: "uppercase", letterSpacing: 1.5, opacity: 0.65 }}>
        Brand comparison
      </span>
      <span style={{ opacity: 0.25 }}>—</span>
      <span style={{ opacity: 0.7 }}>You're viewing</span>

      <div
        style={{
          display: "inline-flex",
          gap: 2,
          background: "rgba(244,239,228,0.08)",
          borderRadius: 999,
          padding: 3,
        }}
      >
        <Link
          to="/compare/brand-a"
          style={{
            padding: "5px 14px",
            borderRadius: 999,
            textDecoration: "none",
            color: isA ? "#0F2A2A" : "#F4EFE4",
            background: isA ? "#F4EFE4" : "transparent",
            fontWeight: 500,
            transition: "all 160ms ease",
          }}
        >
          A · Editorial
        </Link>
        <Link
          to="/compare/brand-b"
          style={{
            padding: "5px 14px",
            borderRadius: 999,
            textDecoration: "none",
            color: !isA ? "#0F2A2A" : "#F4EFE4",
            background: !isA ? "#F4EFE4" : "transparent",
            fontWeight: 500,
            transition: "all 160ms ease",
          }}
        >
          B · Classic
        </Link>
      </div>

      <span style={{ marginLeft: "auto", opacity: 0.55 }}>
        {isA
          ? "Editorial typography + 5-tier severity"
          : "Classic product interface"}
      </span>
    </div>
  );
}
